// Manda para o BFF (POST /api/erros-cliente → log, Sentry e sistema_erros) os erros que quebram tela no navegador:
// o ErrorBoundary e os erros não tratados (window.onerror / unhandledrejection). Só com sessão; no máximo 1 envio
// por mensagem a cada minuto; nunca lança (reportar erro não pode gerar outro erro).
import { getSessao } from './auth';

const enviados = new Map<string, number>();
const IGNORAR = /ResizeObserver loop|Failed to fetch dynamically imported module|Importing a module script failed|Loading chunk|AbortError/i;

export function reportarErro(erro: unknown, extra?: { origem?: string }): void {
  try {
    const sessao = getSessao();
    if (!sessao?.token) return;
    const e = erro instanceof Error ? erro : new Error(typeof erro === 'string' ? erro : JSON.stringify(erro));
    if (IGNORAR.test(e.message)) return;
    const chave = e.message.slice(0, 200);
    const agora = Date.now();
    if (agora - (enviados.get(chave) ?? 0) < 60_000) return;
    enviados.set(chave, agora);
    void fetch('/api/erros-cliente', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${sessao.token}` },
      body: JSON.stringify({ mensagem: `${extra?.origem ? `[${extra.origem}] ` : ''}${e.message}`, pilha: e.stack ?? '', rota: location.pathname + location.search, versao: (import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA as string | undefined) ?? '' }),
      keepalive: true,
    }).catch(() => undefined);
  } catch { /* nunca propaga */ }
}

/** Liga os ouvintes globais (uma vez, no main.tsx). */
export function ouvirErrosGlobais(): void {
  window.addEventListener('error', (ev) => reportarErro(ev.error ?? ev.message, { origem: 'window' }));
  window.addEventListener('unhandledrejection', (ev) => reportarErro(ev.reason, { origem: 'promise' }));
}
